/* ============================================================
   CLAIREVIEW PEPTIDES — cp-free-gift.js
   Automatic free-gift-with-purchase — dual promo system.

   Promo "order": the cart contains this gift line IFF there is at
   least one real (non-gift) line item.
   Promo "min": the cart contains this gift line IFF the paid
   subtotal (all non-gift lines) is >= its configured minimum.

   Each promo's gift line is tagged with a hidden line item property
   (_cp_gift: "order" | "min") so the two self-heal independently —
   removing one never removes the other. Self-heals after every
   cart mutation, regardless of how it happened.
   ============================================================ */
(function () {
  'use strict';

  var cfg = window.FREE_GIFT;
  if (!cfg) return;

  var PROMOS = [];
  if (cfg.order && cfg.order.id) {
    PROMOS.push({
      key: 'order',
      id: cfg.order.id,
      title: cfg.order.title,
      image: cfg.order.image,
      toast: cfg.order.toast || 'Free gift added to your order!',
      condition: function (cart) { return realCount(cart) >= 1; }
    });
  }
  if (cfg.min && cfg.min.id) {
    PROMOS.push({
      key: 'min',
      id: cfg.min.id,
      title: cfg.min.title,
      image: cfg.min.image,
      toast: cfg.min.toast || 'Free gift unlocked!',
      condition: function (cart) { return paidSubtotal(cart) >= (cfg.min.amount || 0) * 100; }
    });
  }
  if (!PROMOS.length) return;

  var busy = false;
  var pending = false;

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function isGiftItem(item) {
    return !!(item.properties && (item.properties._cp_gift === 'order' || item.properties._cp_gift === 'min'));
  }
  function realCount(cart) {
    return cart.items.reduce(function (n, i) { return n + (isGiftItem(i) ? 0 : i.quantity); }, 0);
  }
  function paidSubtotal(cart) {
    return cart.items.reduce(function (n, i) { return n + (isGiftItem(i) ? 0 : i.final_line_price); }, 0);
  }
  function giftLine(cart, key) {
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].properties && cart.items[i].properties._cp_gift === key) return cart.items[i];
    }
    return null;
  }
  function updateCounts(cart) {
    document.querySelectorAll('[data-cp-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.classList.toggle('is-empty', cart.item_count === 0);
    });
  }
  function isCartPage() { return !!document.querySelector('[data-cp-cart-page]'); }

  function addGift(promo) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: promo.id, quantity: 1, properties: { _cp_gift: promo.key } })
    });
  }
  function removeGift(key) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
  }

  function enforce(trigger) {
    if (busy) { pending = true; return Promise.resolve(); }
    busy = true;

    return getCart().then(function (cart) {
      updateCounts(cart);

      /* Both conditions only look at non-gift lines, so the full
         desired state can be computed from this single snapshot
         without re-fetching between mutations. */
      var actions = [];
      PROMOS.forEach(function (promo) {
        var should = promo.condition(cart);
        var line = giftLine(cart, promo.key);
        if (should && !line) actions.push({ type: 'add', promo: promo });
        else if (!should && line) actions.push({ type: 'remove', promo: promo, key: line.key });
      });
      if (!actions.length) return;

      var added = [];
      var removedAny = false;
      var chain = Promise.resolve();
      actions.forEach(function (action) {
        chain = chain.then(function () {
          if (action.type === 'add') { added.push(action.promo); return addGift(action.promo); }
          removedAny = true;
          return removeGift(action.key);
        });
      });

      return chain.then(getCart).then(function (c2) {
        updateCounts(c2);
        if (trigger === 'mutation') {
          if (added.length) { celebrate(added, true); }
          if (removedAny && !added.length) { reloadOnce(); }
        } else if (trigger === 'load' && isCartPage()) {
          /* Reload renders the correct line items; stash the
             celebration so it survives the reload instead of
             flashing away before the new markup paints. */
          if (added.length) {
            try {
              sessionStorage.setItem('cp_gift_celebrate', JSON.stringify(added.map(function (p) {
                return { title: p.title, image: p.image, toast: p.toast };
              })));
            } catch (e) {}
          }
          reloadOnce();
        }
      });
    }).catch(function () {}).then(function () {
      busy = false;
      if (pending) { pending = false; enforce('mutation'); }
    });
  }

  var reloaded = false;
  function reloadOnce() { if (reloaded) return; reloaded = true; window.location.reload(); }

  /* ---- Intercept AJAX cart mutations ---- */
  var origFetch = window.fetch;
  window.fetch = function () {
    var input = arguments[0];
    var url = (input && input.url) || input || '';
    var p = origFetch.apply(this, arguments);
    if (typeof url === 'string' && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
      return p.then(function (res) { enforce('mutation'); return res; });
    }
    return p;
  };

  /* ---- Celebration: gift toast (with thumbnail) + fly-to-cart ---- */
  function celebrate(promos, fly) {
    promos.forEach(function (promo) {
      if (window.CP && window.CP.toast) {
        window.CP.toast(promo.toast, { title: 'FREE GIFT UNLOCKED', gift: true, image: promo.image });
      }
      if (fly && window.CP && window.CP.flyToCart) {
        window.CP.flyToCart(promo.image);
      }
    });
  }

  /* ---- Silent page-load pass ---- */
  function pendingCelebrate() {
    try {
      var raw = sessionStorage.getItem('cp_gift_celebrate');
      if (!raw) return;
      sessionStorage.removeItem('cp_gift_celebrate');
      var promos = JSON.parse(raw);
      if (promos && promos.length) { celebrate(promos, false); }
    } catch (e) {}
  }
  function boot() { pendingCelebrate(); enforce('load'); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); }
  else { boot(); }
})();
